import React from 'react';
import styled from 'styled-components';
import { Box, Heading, Image, Paragraph, ResponsiveContext } from 'grommet';
import GatsbyButton from '../GatsbyButton';

const StyledImage = styled(Image)`
  max-width: 315px;
  max-height: 150px;
  width: 100%;
`;

export default function({ Link, background, headline, body, buttonText, buttonUrl, images }) {
  if (!images) return null;

  return (
    <ResponsiveContext.Consumer>
      {(size) => {
        const small = size === 'small';
        const hero = size === 'hero';

        return (
          <Box
            background={background}
            align="center"
            direction="row-responsive"
            pad={{
              vertical: hero || small ? 'large' : 'xlarge',
              horizontal: hero || small ? 'medium' : 'xlarge',
            }}
          >
            <Box basis="1/2" pad={{ horizontal: hero || small ? 'none' : 'xlarge' }}>
              {headline && (
                <Heading level="2" margin="none">
                  {headline}
                </Heading>
              )}
              {body && <Paragraph>{body}</Paragraph>}
              {buttonUrl && buttonText && (
                <GatsbyButton
                  Link={Link}
                  href={buttonUrl}
                  label={buttonText}
                  color="accent-1"
                  alignSelf={small ? 'stretch' : 'start'}
                  primary
                />
              )}
            </Box>
            <Box direction="row" justify="around" flex wrap>
              {images &&
                images.map((src) => (
                  <Box basis={images.length > 3 ? '1/3' : '1/2'} align="center">
                    <StyledImage src={src} fit="contain" />
                  </Box>
                ))}
            </Box>
          </Box>
        );
      }}
    </ResponsiveContext.Consumer>
  );
}
